// import { Component, OnInit, ViewChild } from "@angular/core";
// import { BaseComponent } from "../../pages/base.component";
// import { ToastrService } from "ngx-toastr";
// import { CommonService } from "src/app/services/common.service";
// import { FileuploadService } from "src/app/services/fileupload.service";
// import { Router } from "@angular/router";
// import { DataTableDirective } from "angular-datatables";

// @Component({
//   selector: 'app-qaso-dashboard',
//   templateUrl: './qaso-dashboard.component.html',
//   styleUrls: ['./qaso-dashboard.component.css']
// })
// export class QasoDashboardComponent extends BaseComponent implements OnInit {
//   @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
//   dashboardDetails: any = ""; viewDocLst: any[] = [];
//   countyName: any = ""; upcmngInspctnDtls: any[] = []; pastInspctnDtls: any[] = [];
//   subCounty: any = '';

//   constructor(
//     protected CommonService: CommonService,
//     protected toastr: ToastrService,
//     private route: Router
//   ) {
//     super(CommonService, toastr);
//     let userData: any = JSON.parse(sessionStorage.getItem('userData'))
//     this.subCounty = userData?.sub_counties_name;
//   }

//   ngOnInit(): void {
//     this.dtOptions = {
//       pagingType: "full_numbers",
//       pageLength: 5,
//       processing: true,
//       dom: "frtip",
//       buttons: [
//         {
//           extend: "excelHtml5",
//           title: "Past Inspections",
//           exportOptions: {
//             columns: [0, 1, 2] // Institution, Status, Date - exclude Actions
//           },
//         }
//       ],
//     };
//     this.LoadDBDitails(), this.LoadUpcmngInspctn(), this.LoadPastInspctn();

//   }

//   async LoadDBDitails() {
//     let roleId: any = 0;
//     const decryptedValue: any = await this.CommonService.decryptAesGcm(
//       localStorage.getItem("RoleId"),
//       this.CommonService.secretKey
//     );
//     roleId = decryptedValue;
//     // this.CommonService.decrypt$(localStorage.getItem("RoleId")).subscribe(value => {
//     //   roleId = value;
//     // });
//     const userData = JSON.parse(sessionStorage.getItem("userData"));
//     this.countyName = userData?.counties_name;
//     this.dashboardDetails = "";
//     // let payLoad = {
//     //   v_tnt_code: localStorage.getItem("TenantCode"),
//     //   v_county_id: userData?.county_id,
//     //   v_sub_county_id: userData?.subcounty_id,
//     //   v_role_id: localStorage.getItem("RoleId"),
//     // };
//     let payLoad = {
//       QASO_USERID: localStorage.getItem("UserId"),
//       SCHOOLLEVEL :localStorage.getItem('schoolLevelID'),
//     };
//     this.CommonService.postCall(
//       `Dashboard/LoadSCQASODashboardInstitution`,
//       payLoad
//     ).subscribe((res: any) => {
//       this.dashboardDetails = res;
//       // Labels: sub-county names (field named 'reject' in payload)
//       // Datasets: Total and Pending series
//     });
//   }


//   LoadUpcmngInspctn() {
//     this.upcmngInspctnDtls = []
//     const now = new Date();
//     const yearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
//     let payLoad = { QASO_USERID: localStorage.getItem("UserId"), INSPECTION_DATE: yearMonth,
//       SCHOOLLEVEL :localStorage.getItem('schoolLevelID') };
//     this.CommonService.postCall(`Dashboard/GetUpcomingInspectionsList`, payLoad ).subscribe((res: any) => {
//       this.upcmngInspctnDtls = res ?? [];
//       // Labels: sub-county names (field named 'reject' in payload)
//       // Datasets: Total and Pending series
//     });
//   }


//   LoadPastInspctn() {
//     this.pastInspctnDtls = []
//     const now = new Date();
//     const yearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
//     let payLoad = { QASO_USERID: localStorage.getItem("UserId"), INSPECTION_DATE: yearMonth,
//       SCHOOLLEVEL :localStorage.getItem('schoolLevelID') };
//     this.CommonService.postCall(`Dashboard/GetPastInspectionsList`, payLoad ).subscribe((res: any) => {
//       this.pastInspctnDtls = res ?? [];
//       // Labels: sub-county names (field named 'reject' in payload)
//       // Datasets: Total and Pending series
//     });
//   }

//   getPercentage(
//     value: number,
//     total: number,
//     reject: number,
//     pending: number
//   ): string {
//     const numValue = value || 0;
//     const numTotal = total || 0;
//     const numReject = reject || 0;
//     const numPending = pending || 0;

//     const sum = numTotal + numReject + numPending;

//     if (sum === 0) {
//       return "0";
//     }

//     const percentage = (numValue / sum) * 100;
//     return percentage.toFixed(1);
//   }

//   getSegmentLength(segmentType: string): number {
//     const total = +this.dashboardDetails?.institutionType?.PRE_PRIMARY || 0;
//     const reject = +this.dashboardDetails?.institutionType?.JUNIOR_SCHOOL || 0;
//     const pending =
//       +this.dashboardDetails?.institutionType?.SENIOR_SCHOOL || 0;

//     const sum = total + reject + pending;

//     if (sum === 0) {
//       return 0;
//     }

//     let value = 0;
//     switch (segmentType) {
//       case "Pre-primary":
//         value = total;
//         break;
//       case "Junior School":
//         value = reject;
//         break;
//       case "Senior School":
//         value = pending;
//         break;
//     }

//     return (value / sum) * 502.4;
//   }
//   navigateToReview(ctrl: any = 0) {
//     this.CommonService.statusId.next(ctrl),
//     this.route.navigate(["/HOME/registration/qasoInspection/5097"]);
//   }

//   exportPastInspections() {
//     if (this.pastInspctnDtls.length === 0) {
//       this.toastr.info("No data to export");
//       return;
//     }
//     if (this.dtElement?.dtInstance) {
//       this.dtElement.dtInstance.then((dtInstance: any) => {
//         dtInstance.button(".buttons-excel").trigger();
//       });
//     }
//   }

//   extractCleanFileName(fileName: string): string { // fileName only display
//     // Match the dynamic middle part using regex
//     const match = fileName.match(/^[^_]+_[^_]+_(.+)_\d+\.pdf$/);
//     if (match && match[1]) {
//       return `${match[1]}.pdf`; // e.g., "InstituteRegistrationCertificate.pdf"
//     }
  
//     // Fallback: return original file name
//     return fileName;
//   }

//   // ngOnDestroy(): void {
//   //   this.CommonService.statusId.next(0);
//   // }

// }


import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { BaseComponent } from "../../pages/base.component";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";
import { FileuploadService } from "src/app/services/fileupload.service";
import { ActivatedRoute, Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-qaso-dashboard',
  templateUrl: './qaso-dashboard.component.html',
  styleUrls: ['./qaso-dashboard.component.css']
})
export class QasoDashboardComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dashboardDetails: any = ""; 
  viewDocLst: any[] = [];
  countyName: any = ""; 
  upcmngInspctnDtls: any[] = []; 
  pastInspctnDtls: any[] = [];
  subCounty: any = '';
  private querySubscription: Subscription = new Subscription();

  constructor(
    protected CommonService: CommonService,
    protected toastr: ToastrService,
    private route: Router,
    private active: ActivatedRoute
  ) {
    super(CommonService, toastr);
    let userData: any = JSON.parse(sessionStorage.getItem('userData'))
    this.subCounty = userData?.sub_counties_name;
  }

  ngOnInit(): void {
    // Subscribe to query params changes
    this.querySubscription = this.active.queryParams.subscribe((res: any) => {
      // Reload data when cd=true or when school level changes (reload flag)
      if (res.cd == 'true' || res.reload === 'true') {
        this.LoadDBDitails();
        this.LoadUpcmngInspctn();
        this.LoadPastInspctn();
      }
    });
    
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 5,
      processing: true,
      dom: "frtip",
      buttons: [
        {
          extend: "excelHtml5",
          title: "Past Inspections",
          exportOptions: {
            columns: [0, 1, 2] // Institution, Status, Date - exclude Actions
          },
        }
      ],
    };
    this.LoadDBDitails();
    this.LoadUpcmngInspctn();
    this.LoadPastInspctn();
  }

  ngOnDestroy(): void {
    // Clean up subscriptions to prevent memory leaks
    if (this.querySubscription) {
      this.querySubscription.unsubscribe();
    }
  }

  async LoadDBDitails() {
    let roleId: any = 0;
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      localStorage.getItem("RoleId"),
      this.CommonService.secretKey
    );
    roleId = decryptedValue;
    
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    this.countyName = userData?.counties_name;
    this.dashboardDetails = "";
    const currentSchoolLevel = localStorage.getItem('schoolLevelID') || "";
    
    let payLoad = {
      QASO_USERID: localStorage.getItem("UserId"),
      SCHOOLLEVEL: currentSchoolLevel,
    };
    
    this.CommonService.postCall(
      `Dashboard/LoadSCQASODashboardInstitution`,
      payLoad
    ).subscribe((res: any) => {
      this.dashboardDetails = res;
    });
  }

  LoadUpcmngInspctn() {
    this.upcmngInspctnDtls = []
    const now = new Date();
    const yearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    const currentSchoolLevel = localStorage.getItem('schoolLevelID') || "";
    
    let payLoad = { 
      QASO_USERID: localStorage.getItem("UserId"), 
      INSPECTION_DATE: yearMonth,
      SCHOOLLEVEL: currentSchoolLevel 
    };
    
    this.CommonService.postCall(`Dashboard/GetUpcomingInspectionsList`, payLoad).subscribe((res: any) => {
      this.upcmngInspctnDtls = res ?? [];
    });
  }

  LoadPastInspctn() {
    this.pastInspctnDtls = []
    const now = new Date();
    const yearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    const currentSchoolLevel = localStorage.getItem('schoolLevelID') || "";
    
    let payLoad = { 
      QASO_USERID: localStorage.getItem("UserId"), 
      INSPECTION_DATE: yearMonth,
      SCHOOLLEVEL: currentSchoolLevel 
    };
    
    this.CommonService.postCall(`Dashboard/GetPastInspectionsList`, payLoad).subscribe((res: any) => {
      this.pastInspctnDtls = res ?? [];
      // Refresh DataTable if needed
      if (this.dtElement?.dtInstance) {
        this.dtElement.dtInstance.then((dtInstance: any) => {
          dtInstance.destroy();
          setTimeout(() => {
            this.dtOptions = { ...this.dtOptions };
          }, 100);
        });
      }
    });
  }

  getPercentage(
    value: number,
    total: number,
    reject: number,
    pending: number
  ): string {
    const numValue = value || 0;
    const numTotal = total || 0;
    const numReject = reject || 0;
    const numPending = pending || 0;

    const sum = numTotal + numReject + numPending;

    if (sum === 0) {
      return "0";
    }

    const percentage = (numValue / sum) * 100;
    return percentage.toFixed(1);
  }

  getSegmentLength(segmentType: string): number {
    const total = +this.dashboardDetails?.institutionType?.PRE_PRIMARY || 0;
    const reject = +this.dashboardDetails?.institutionType?.JUNIOR_SCHOOL || 0;
    const pending = +this.dashboardDetails?.institutionType?.SENIOR_SCHOOL || 0;

    const sum = total + reject + pending;

    if (sum === 0) {
      return 0;
    }

    let value = 0;
    switch (segmentType) {
      case "Pre-primary":
        value = total;
        break;
      case "Junior School":
        value = reject;
        break;
      case "Senior School":
        value = pending;
        break;
    }

    return (value / sum) * 502.4;
  }
  
  navigateToReview(ctrl: any = 0) {
    this.CommonService.statusId.next(ctrl);
    this.route.navigate(["/HOME/registration/qasoInspection/5097"]);
  }

  exportPastInspections() {
    if (this.pastInspctnDtls.length === 0) {
      this.toastr.info("No data to export");
      return;
    }
    if (this.dtElement?.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: any) => {
        dtInstance.button(".buttons-excel").trigger();
      });
    }
  }

  extractCleanFileName(fileName: string): string {
    // Match the dynamic middle part using regex
    const match = fileName.match(/^[^_]+_[^_]+_(.+)_\d+\.pdf$/);
    if (match && match[1]) {
      return `${match[1]}.pdf`;
    }
    // Fallback: return original file name
    return fileName;
  }
}